(function () {
  'use strict';

  if (window.__THQProductScriptLoaded) {
    if (typeof window.__THQProductInit === 'function') window.__THQProductInit(document);
    return;
  }
  window.__THQProductScriptLoaded = true;

  var SECTION_SELECTOR = '[data-thq-product-section]';

  function dispatchVariantEvents(section, variant) {
    if (!variant || !variant.id) return;

    var masterInput = section.querySelector('[data-thq-master-variant]');
    if (masterInput) {
      masterInput.value = String(variant.id);
      masterInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    document.dispatchEvent(
      new CustomEvent('variantChanged', {
        detail: { variantId: variant.id }
      })
    );
  }

  function updateSelectedOptionLabel(input) {
    var optionGroup = input.closest('[data-thq-option-group]');
    if (!optionGroup) return;

    var selectedLabel = optionGroup.querySelector('[data-thq-selected-option]');
    if (selectedLabel) selectedLabel.textContent = input.value || '';
  }

  function bindVariantBridge(section) {
    section.addEventListener('change', function (event) {
      var optionInput = event.target.closest('[data-thq-option-input]');
      if (optionInput) updateSelectedOptionLabel(optionInput);
    });

    if (window.jQuery) {
      window.jQuery(section)
        .off('variantChange.thqProduct')
        .on('variantChange.thqProduct', function (event) {
          dispatchVariantEvents(section, event.variant);
        });
    }
  }

  function bindQuantity(section) {
    section.addEventListener('click', function (event) {
      var button = event.target.closest('[data-thq-qty-button]');
      if (!button) return;

      var field = button.closest('[data-thq-qty]');
      var input = field ? field.querySelector('input[name="quantity"]') : null;
      if (!input) return;

      event.preventDefault();

      var current = parseInt(input.value, 10);
      var minimum = parseInt(input.min || '1', 10);
      var maximum = input.max ? parseInt(input.max, 10) : null;
      var next = Number.isFinite(current) ? current : minimum;

      if (button.dataset.thqQtyButton === 'plus') next += 1;
      if (button.dataset.thqQtyButton === 'minus') next -= 1;

      next = Math.max(minimum, next);
      if (Number.isFinite(maximum)) next = Math.min(maximum, next);

      input.value = next;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function getThumbnailScrollStep(scrollArea) {
    var item = scrollArea.querySelector('.product-single__thumbnails-item');
    var list = scrollArea.querySelector('.thq-product__thumbnail-list');
    if (!item) return Math.max(72, scrollArea.clientHeight * 0.25);

    var gap = 0;
    if (list) {
      var styles = window.getComputedStyle(list);
      gap = parseFloat(styles.rowGap || styles.gap || '0') || 0;
    }

    return item.getBoundingClientRect().height + gap;
  }

  function updateThumbnailScrollState(shell) {
    if (!shell) return;

    var scrollArea = shell.querySelector('[data-thq-thumbnail-scroll]');
    if (!scrollArea) return;

    var maxScroll = Math.max(0, scrollArea.scrollHeight - scrollArea.clientHeight);
    var canScrollUp = scrollArea.scrollTop > 2;
    var canScrollDown = scrollArea.scrollTop < maxScroll - 2;

    shell.classList.toggle('can-scroll-up', canScrollUp);
    shell.classList.toggle('can-scroll-down', canScrollDown);

    var upButton = shell.querySelector('[data-thq-thumb-scroll="up"]');
    var downButton = shell.querySelector('[data-thq-thumb-scroll="down"]');
    if (upButton) upButton.disabled = !canScrollUp;
    if (downButton) downButton.disabled = !canScrollDown;
  }

  function bindThumbnailRail(section) {
    var shell = section.querySelector('[data-thq-thumbnail-shell]');
    if (!shell) return;

    var scrollArea = shell.querySelector('[data-thq-thumbnail-scroll]');
    if (!scrollArea) return;

    function refreshState() {
      window.requestAnimationFrame(function () {
        updateThumbnailScrollState(shell);
      });
    }

    shell.addEventListener('click', function (event) {
      var button = event.target.closest('[data-thq-thumb-scroll]');
      if (!button || button.disabled) return;

      event.preventDefault();
      var direction = button.dataset.thqThumbScroll === 'up' ? -1 : 1;
      scrollArea.scrollBy({
        top: direction * getThumbnailScrollStep(scrollArea),
        behavior: 'smooth'
      });
    });

    scrollArea.addEventListener(
      'wheel',
      function (event) {
        if (window.matchMedia('(max-width: 767px)').matches) return;
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

        var maxScroll = Math.max(0, scrollArea.scrollHeight - scrollArea.clientHeight);
        var movingDown = event.deltaY > 0;
        var canMove = movingDown
          ? scrollArea.scrollTop < maxScroll - 2
          : scrollArea.scrollTop > 2;

        if (!canMove) return;

        event.preventDefault();
        scrollArea.scrollTop += event.deltaY;
      },
      { passive: false }
    );

    scrollArea.addEventListener('scroll', refreshState, { passive: true });
    window.addEventListener('resize', refreshState, { passive: true });

    if (window.ResizeObserver) {
      var observer = new ResizeObserver(refreshState);
      observer.observe(scrollArea);
      var list = scrollArea.querySelector('.thq-product__thumbnail-list');
      if (list) observer.observe(list);
    }

    refreshState();
  }

  function setActiveThumbnail(section, slideIndex) {
    var active = null;
    section.querySelectorAll('[data-thq-thumbnail]').forEach(function (thumb) {
      var isActive = Number(thumb.dataset.slide) === Number(slideIndex);
      thumb.classList.toggle('activeSlide', isActive);
      thumb.classList.toggle('active-thumb', isActive);
      thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      if (isActive) active = thumb;
    });

    if (active) {
      var scrollArea = active.closest('[data-thq-thumbnail-scroll]');
      if (scrollArea) {
        if (window.matchMedia('(max-width: 767px)').matches) {
          var activeLeft = active.offsetLeft;
          var activeRight = activeLeft + active.offsetWidth;
          var visibleLeft = scrollArea.scrollLeft;
          var visibleRight = visibleLeft + scrollArea.clientWidth;

          if (activeLeft < visibleLeft) scrollArea.scrollTo({ left: activeLeft, behavior: 'smooth' });
          if (activeRight > visibleRight) {
            scrollArea.scrollTo({ left: activeRight - scrollArea.clientWidth, behavior: 'smooth' });
          }
        } else {
          var activeTop = active.offsetTop;
          var activeBottom = activeTop + active.offsetHeight;
          var visibleTop = scrollArea.scrollTop;
          var visibleBottom = visibleTop + scrollArea.clientHeight;

          if (activeTop < visibleTop) scrollArea.scrollTo({ top: activeTop, behavior: 'smooth' });
          if (activeBottom > visibleBottom) {
            scrollArea.scrollTo({ top: activeBottom - scrollArea.clientHeight, behavior: 'smooth' });
          }
        }
      }
    }
  }

  function updateMainGalleryNav(section, currentSlide, slideCount) {
    var previous = section.querySelector('[data-thq-gallery-nav="prev"]');
    var next = section.querySelector('[data-thq-gallery-nav="next"]');
    var count = Number(slideCount || 0);
    var current = Number(currentSlide || 0);

    if (previous) previous.disabled = count <= 1 || current <= 0;
    if (next) next.disabled = count <= 1 || current >= count - 1;
  }

  function bindGallery(section) {
    var slider = section.querySelector('[data-thq-main-slider]');
    if (!slider) return;

    section.addEventListener('click', function (event) {
      var galleryButton = event.target.closest('[data-thq-gallery-nav]');
      if (galleryButton && section.contains(galleryButton)) {
        event.preventDefault();
        if (galleryButton.disabled || !window.jQuery) return;

        var $slider = window.jQuery(slider);
        if (!$slider.hasClass('slick-initialized')) return;

        $slider.slick(
          galleryButton.dataset.thqGalleryNav === 'prev' ? 'slickPrev' : 'slickNext'
        );
        return;
      }

      var thumb = event.target.closest('[data-thq-thumbnail]');
      if (!thumb || !section.contains(thumb)) return;

      event.preventDefault();
      var slideIndex = Number(thumb.dataset.slide || 0);

      /* Update the thumbnail immediately before Slick begins the media change.
         This keeps the border response feeling instant even when the next image
         takes a moment to render. */
      setActiveThumbnail(section, slideIndex);

      if (window.jQuery && window.jQuery(slider).hasClass('slick-initialized')) {
        window.jQuery(slider).slick('slickGoTo', slideIndex);
      }
    });

    if (window.jQuery) {
      var $slider = window.jQuery(slider);
      $slider
        .off('init.thqProduct reInit.thqProduct afterChange.thqProduct')
        .on('init.thqProduct reInit.thqProduct afterChange.thqProduct', function (event, slick, currentSlide) {
          var current = Number.isFinite(Number(currentSlide)) ? Number(currentSlide) : Number(slick.currentSlide || 0);
          setActiveThumbnail(section, current);
          updateMainGalleryNav(section, current, slick.slideCount);
        });

      if ($slider.hasClass('slick-initialized')) {
        var slickInstance = $slider.slick('getSlick');
        setActiveThumbnail(section, slickInstance.currentSlide || 0);
        updateMainGalleryNav(section, slickInstance.currentSlide || 0, slickInstance.slideCount);
      } else {
        updateMainGalleryNav(section, 0, slider.children.length);
      }
    } else {
      updateMainGalleryNav(section, 0, slider.children.length);
    }
  }

  function closeSiblingAccordions(current) {
    var group = current.closest('[data-thq-accordion-group]') || current.closest(SECTION_SELECTOR);
    if (!group) return;

    group.querySelectorAll('[data-thq-accordion][open]').forEach(function (details) {
      if (details !== current) details.removeAttribute('open');
    });
  }

  function applyAccordionDefaults(root) {
    (root || document).querySelectorAll('[data-thq-accordion-group]').forEach(function (group) {
      var shouldOpenFirst = group.getAttribute('data-open-first') === 'true';
      if (!shouldOpenFirst || group.querySelector('[data-thq-accordion][open]')) return;

      var first = group.querySelector('[data-thq-accordion]');
      if (first) first.setAttribute('open', '');
    });
  }

  function bindAccordions(section) {
    applyAccordionDefaults(section);

    section.addEventListener(
      'toggle',
      function (event) {
        var current = event.target;
        if (!current.matches('[data-thq-accordion]') || !current.open) return;
        closeSiblingAccordions(current);
      },
      true
    );
  }

  function initSection(section) {
    if (!section || section.dataset.thqInitialized === 'true') return;
    section.dataset.thqInitialized = 'true';

    bindVariantBridge(section);
    bindQuantity(section);
    bindThumbnailRail(section);
    bindGallery(section);
    bindAccordions(section);
  }

  function initAll(root) {
    (root || document).querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  window.__THQProductInit = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var details = event.target.querySelector ? event.target.querySelector('[data-thq-accordion]') : null;
    if (!details) return;

    details.setAttribute('open', '');
    closeSiblingAccordions(details);
  });

  document.addEventListener('shopify:block:load', function (event) {
    applyAccordionDefaults(event.target);
  });
})();